/**
 * Плагин: при добавлении edge с флагом _fromUserConnection шлём patch addConnection.
 * Флаг выставляется при создании связи через «режим связи» или перетаскивание, но не при рисовании (edge:connected).
 */
export default {
	init(modeler, context) {
		const {graph, onPatch, viewIndex} = context;
		const VIEW_INDEX = viewIndex ?? 0;

		const onEdgeAdded = args => {
			const edge = args?.edge ?? args?.cell;
			if (!edge || typeof edge.isEdge !== 'function' || !edge.isEdge()) return;
			if (!edge.getData?.('_fromUserConnection')) return;
			edge.setData?.({...edge.getData?.(), _fromUserConnection: false});
			const id = edge.id;
			const viewElement = modeler._findViewElementById(id);
			if (!viewElement?.relationshipRef) return;
			const rel = viewElement.relationshipRef;
			const getElementId = o => o?.id ?? o?.$attrs?.id;
			const relationshipRefId = getElementId(rel);
			const sourceId = edge.getSourceCellId?.() ?? edge.getSource?.()?.cell;
			const targetId = edge.getTargetCellId?.() ?? edge.getTarget?.()?.cell;
			if (!sourceId || !targetId) return;
			const relationshipType = modeler._getRelationshipType?.(viewElement) ?? 'Association';
			const vertices = edge.getVertices?.() ?? [];
			const bendpoints = vertices.map(p => ({x: p.x ?? p.$x ?? 0, y: p.y ?? p.$y ?? 0}));
			onPatch({
				patches: [
					{
						op: 'addConnection',
						viewIndex: VIEW_INDEX,
						connection: {
							identifier: id,
							source: sourceId,
							target: targetId,
							relationshipRef: relationshipRefId,
							type: relationshipType,
							bendpoints,
						},
					},
				],
			});
		};

		graph.on('edge:added', onEdgeAdded);

		return () => graph.off('edge:added', onEdgeAdded);
	},
};
